import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6e1f2beb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "event-type-badge" }


export default /*#__PURE__*/_defineComponent({
  __name: 'event-type-badge',
  props: {
    eventTypeName: {}
  },
  emits: ["remove-event-type"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

function removeEventType(): void {
  emit("remove-event-type");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.eventTypeName), 1),
    _createElementVNode("span", {
      class: "glyphicon glyphicon-remove",
      onClick: removeEventType,
      onKeydown: _withKeys(removeEventType, ["space"])
    }, null, 32)
  ]))
}
}

})